import { useState } from "react";
import { Link } from "react-router-dom";
export default function BlogSection() {
  // Sample blog data - you would likely fetch this from an API in a real application
  const [blogPosts] = useState([
    {
      id: 1,
      title: "Master the Art of Proposal Writing",
      date: "April 15, 2025",
      category: "Business Tips",
      excerpt:
        "Learn the key strategies to craft compelling business proposals that stand out from the competition and win more clients.",
      imageUrl:
        "https://www.uptonbarn.com/wp-content/uploads/2024/07/Lucy-and-Yousef-High-Resolution-832-of-1006-scaled.jpg",
    },
    {
      id: 2,
      title: "How AI is Transforming Proposal Development",
      date: "April 8, 2025",
      category: "Technology",
      excerpt:
        "Discover how SelectProposal's AI-powered tools are helping businesses create winning proposals in less time with greater accuracy.",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSq4447GYAE6Wl-B9lmDr7Z-GjFVWXQt7HGaw&s",
    },
    {
      id: 3,
      title: "Client Success Story: From Startup to Industry Leader",
      date: "March 30, 2025",
      category: "Success Stories",
      excerpt:
        "See how one of our clients used SelectProposal to secure major contracts and grow their business exponentially in just 18 months.",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcZdengGsiEcXWajdsUEoct_8eocP4xwwS9Q&s",
    },
  ]);

  return (
    <section className=" py-16 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Blog Header */}
        <div className="text-center mb-16">
          <h2 className="text-center font-alex text-6xl font-semibold text-[#730000]  max-lg:text-5xl max-sm:text-4xl">
            Latest Updates
          </h2>
          <div className="w-12 h-1 bg-[#730000] mx-auto mb-6"></div>
          <p className=" m-auto text-2xl max-lg:text-xl max-sm:text-[15px] font-seasons">
            Stay updated with the latest insights on proposal writing, business
            development, and success stories from our clients.
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <div
              key={post.id}
              className="border-b-4 border-red-600 rounded overflow-hidden transition-transform duration-300 hover:-translate-y-1"
            >
              {/* Blog Image */}
              <div className="h-52 overflow-hidden">
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Blog Content */}
              <div className="p-6">
                <h3 className="text-xl font-serif font-bold mb-3 text-[#730000]">
                  {post.title}
                </h3>
                <div className="flex items-center mb-3 text-sm text-yellow-500">
                  <span className="mr-4">{post.date}</span>
                  <span>{post.category}</span>
                </div>
                <p className="text-gray-400 mb-6 text-sm">{post.excerpt}</p>
                <div className="w-full flex flex-row max-md:items-center max-md:justify-center">
                <Link
                  to="/blogs"
                  className="inline-block px-6 py-2 bg-[#730000] text-white font-semibold rounded hover:bg-[#b83d3d] transition-colors"
                >
                  Read More
                </Link>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Back to Top Button */}
      {/* <a
        href="#"
        className="fixed bottom-6 right-6 w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center text-black"
      >
        ↑
      </a> */}
    </section>
  );
}
